/* this file added by Bearer Web Developer  */
import React from 'react';
import styles from './importantNote.module.scss';
import notes from './notes.json';
import { useAppState } from '../../../../states/app-state';
import { observer } from 'mobx-react-lite';
import { ApiIntegrationEnum } from '../../../../states/apiIntegrationState/models/apiIntegrationEnum';
import { useThemeMode } from '../../../../states/contexts/theme';

const ImportantNote: React.FC = observer(() => {
    const appState = useAppState();
    const step = appState?.ApiIntegration?.apiIntegrationStep;
    const note = step === ApiIntegrationEnum.EnableApiIntegration ? notes?.enableNote :
        step === ApiIntegrationEnum.GenerateApiIntegration ? notes?.generateNote : notes?.regenerateNote;
    const { theme } = useThemeMode(); // added by Bearer Web Developer
    return (
        <div className={styles.important_note} data-theme={theme}> {/* data-theme property added by Bearer Web Developer */}
            <h3>
                {theme === 'dark' ? <img src="/important-white.svg" alt="!" /> : <img src="/important.svg" alt="!" />}
                Important note:
            </h3>
            <ul>{note?.map((n, i) => (<li key={i}>{n}</li>))}</ul>
        </div>
    )
});
export default ImportantNote;